import React from 'react';
import useArrayField from '@afosto/app-components-react/ArrayField/useArrayField';
import useRegisterInput from '@afosto/app-components-react/Form/useRegisterInput';
import { useFormContext } from '@afosto/app-components-react/Form';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import TextField from '@afosto/app-components-react/TextField';
import Checkbox from '@afosto/app-components-react/Checkbox';
import translations from './translations';
import useIntl from '@afosto/utils-react/intl/useIntl';

const ROUTE_STRUCTURE = {
  path: '*',
  uri: null,
  isBucket: false,
  isAsOrigin: false,
  isPublic: false,
  age: 31536000,
  isRequired: false,
  scope: null,
};

const RoutesFormSection = () => {
  const name = 'routes';
  useRegisterInput(name);

  const intl = useIntl();
  const formContext = useFormContext();
  const { watch } = formContext ?? {};
  const inputValue = watch(name);

  const { data, append, remove, update } = useArrayField({
    name,
    value: !inputValue?.length ? [ROUTE_STRUCTURE] : inputValue,
    removeIds: false,
  });

  const handleChange = (index, field) => (ev, newValue) => {
    update(index, field)(ev, newValue);
  };

  return (
    <Box mb={2}>
      <Typography variant="overline" color="textPrimary">
        {intl.formatMessage(translations.sections.routes)}
      </Typography>
      <FormControl component="fieldset" variant="outlined" fullWidth>
        {data.map((route, idx) => (
          // eslint-disable-next-line no-underscore-dangle
          <Box py={1} key={route?._id}>
            <Card>
              <CardContent>
                <Box mb={2}>
                  <TextField
                    name="path"
                    label={intl.formatMessage(translations.fields.path.label)}
                    onChange={handleChange(idx, 'path')}
                    value={route?.path}
                    register={false}
                    margin="dense"
                  />

                  <TextField
                    name="uri"
                    label={intl.formatMessage(translations.fields.uri.label)}
                    onChange={handleChange(idx, 'uri')}
                    value={route?.uri}
                    register={false}
                    margin="dense"
                  />

                  <Checkbox
                    name="isBucket"
                    label={intl.formatMessage(translations.fields.isBucket.label)}
                    onChange={handleChange(idx, 'isBucket')}
                    checked={route?.isBucket}
                    register={false}
                  />
                </Box>

                <Box mb={2}>
                  <Typography variant="overline" color="textSecondary">
                    {intl.formatMessage(translations.sections.cache)}
                  </Typography>

                  <Checkbox
                    name="isAsOrigin"
                    label={intl.formatMessage(translations.fields.isAsOrigin.label)}
                    onChange={handleChange(idx, 'isAsOrigin')}
                    checked={route?.isAsOrigin}
                    register={false}
                  />

                  <Checkbox
                    name="isPublic"
                    label={intl.formatMessage(translations.fields.isPublic.label)}
                    onChange={handleChange(idx, 'isPublic')}
                    checked={route?.isPublic}
                    register={false}
                  />

                  <TextField
                    name="age"
                    type="number"
                    label={intl.formatMessage(translations.fields.age.label)}
                    onChange={handleChange(idx, 'age')}
                    value={route?.age}
                    margin="dense"
                    register={false}
                  />
                </Box>

                <Typography variant="overline" color="textSecondary">
                  {intl.formatMessage(translations.sections.auth)}
                </Typography>

                <Checkbox
                  name="isRequired"
                  label={intl.formatMessage(translations.fields.isRequired.label)}
                  onChange={handleChange(idx, 'isRequired')}
                  checked={route?.isRequired}
                  register={false}
                />

                <TextField
                  name="scope"
                  label={intl.formatMessage(translations.fields.scope.label)}
                  onChange={handleChange(idx, 'scope')}
                  value={route?.scope}
                  margin="dense"
                  register={false}
                />
              </CardContent>
              <CardActions>
                <Box marginLeft="auto" px={1} pb={1}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    onClick={() => remove(idx)}
                  >
                    {intl.formatMessage(translations.remove)}
                  </Button>
                </Box>
              </CardActions>
            </Card>
          </Box>
        ))}
        <Button
          color="primary"
          variant="outlined"
          size="small"
          onClick={() => append(ROUTE_STRUCTURE)}
        >
          {intl.formatMessage(translations.add)}
        </Button>
      </FormControl>
    </Box>
  );
};

export default RoutesFormSection;
